import { getActionTimeLength } from '../utility'
import type { GameActionId, Character } from '@mission.io/mission-toolkit'
import { useAction, useCharacter, useGetAction } from './provider'
import { useCurrentVocalTrack } from './customHooks'

/**
 * use the duration for the given action id
 * @param {?GameActionId} actionId
 */
export function useActionDuration(actionId: ?GameActionId): ?number {
	const action = useAction(actionId)

	if (!action) {
		return null
	}
	return getActionTimeLength(action)
}

/**
 * use the current character in the context
 */
export function useCurrentCharacter(): ?Character {
	const vocalTrack = useCurrentVocalTrack()
	const character = useCharacter(vocalTrack?.characterId)
	return character
}

/**
 * uses the context to return a callback which fetches the time length for a provided action
 */
export function useGetActionDuration(): string => ?mixed {
	const getAction = useGetAction()
	return gameActionId => getActionTimeLength(getAction(gameActionId))
}
